import React from 'react';
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHeaderCell,
  cssColorValue,
  semanticColors,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { Table as ArticleTableProps } from 'lib/sanity/types';
import BlockSerializer from 'lib/sanity/ui/BlockSerializer';

const addRtlTextAlign = (component: React.FunctionComponent) => styled(component)`
  [dir='rtl'] & {
    text-align: right;
  }
`;

const textBase = (component: React.FunctionComponent) => styled(component)`
  color: ${cssColorValue(semanticColors.textBase)};
`;

const StyledTableRow = styled(TableRow)`
  border-color: ${cssColorValue(semanticColors.essentialSubdued)};
`;

const StyledTableCell = textBase(addRtlTextAlign(TableCell));
const StyledTableHeaderCell = textBase(addRtlTextAlign(TableHeaderCell));

const ArticleTable = ({ table }: { table: ArticleTableProps }) => {
  const { rows } = table;

  const headerRow = rows[0];
  const bodyRows = rows.slice(1);
  return (
    <TableContainer responsive>
      <Table>
        <thead>
          <StyledTableRow>
            {headerRow.cells &&
              headerRow.cells.map(cell => (
                <StyledTableHeaderCell key={cell._key}>
                  <BlockSerializer value={cell.content} />
                </StyledTableHeaderCell>
              ))}
          </StyledTableRow>
        </thead>
        <tbody>
          {bodyRows.map(row => (
            <StyledTableRow key={row._key}>
              {row.cells &&
                row.cells.map(cell => (
                  <StyledTableCell key={cell._key}>
                    <BlockSerializer value={cell.content} />
                  </StyledTableCell>
                ))}
            </StyledTableRow>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default ArticleTable;
